import React, { Component } from "react";
import { Image, Container } from "react-bootstrap";
import { connect } from "react-redux";
import uuid from "react-uuid";
import errorStrings from "../../errorMessages";
import * as myPlansDocumentActions from "../../store/actions/index";

import classes from "./MyPlan.module.css";
import myplan from "../../assets/images/icon-plan-small.svg";
import document from "../../assets/images/icon-document.svg";
import { withTranslation } from "react-i18next";
import { logFirebaseEvent } from "../../shared/utility";
interface IStateFromProps {
  myPlansDocuments: {
    document_name: string;
    document_url: string;
  }[];
  errorMessage: string;
  myPlansMessage: string;
  error: boolean;
  loading: boolean;
  config_values: {
    customValue: string | null;
    defaultValue: string;
    element: string;
    elementType: string;
    id: string;
    targetPageTitle: string;
  }[];
  t: any;
}
interface IDispatchFromProps {
  onFetchMyPlansDocuments: (
    userId: string,
    pageNumber: number,
    pageSize: number
  ) => void;
}
type Props = IStateFromProps & IDispatchFromProps;
class MyPlan extends Component<Props> {
  myplanUrl = `${process.env.REACT_APP_MYPLAN_PAGE}`;
  state = { pageNumber: 0, pageSize: 0, currentCount: 0 };
  componentDidMount() {
    this.props.onFetchMyPlansDocuments(
      localStorage.getItem("userId")!,
      this.state.pageNumber,
      this.state.pageSize
    );
  }
  render() {
    logFirebaseEvent("MyPlan");
    const { t } = this.props;
    console.log("document list", this.props.myPlansDocuments);

    let documentList: any;
    documentList =
      this.props.myPlansDocuments && this.props.myPlansDocuments.length > 0 ? (
        <ul>
          {this.props.myPlansDocuments.map((res) => (
            <li key={uuid()}>
              <a
                href={res.document_url}
                rel="noopener noreferrer"
                target="_blank"
              >
                <h4>{res.document_name}</h4>
                <Image src={document} alt={document} />
              </a>
            </li>
          ))}
        </ul>
      ) : this.props.myPlansMessage ? (
        <div className="no-data">
          <div className="no-data-msg">{this.props.myPlansMessage}</div>
        </div>
      ) : this.props.error && this.props.errorMessage ? (
        <div className="no-data">
          <div className="no-data-msg">
            {errorStrings(this.props.errorMessage)
              ? t(errorStrings(this.props.errorMessage))
              : this.props.errorMessage}
          </div>
        </div>
      ) : (
        <div className="no-data">
          <div className="no-data-msg">{t("myPlan.noDocumentFound")}</div>
        </div>
      );

    return (
      <Container fluid>
        <div className="inner-banner">
          <div className="inner-banner-title">
            <h3>
              {" "}
              {this.props.config_values &&
              this.props.config_values.find(
                (ele) =>
                  ele.targetPageTitle.toLowerCase() === "Home".toLowerCase() &&
                  ele.element.toLowerCase() ===
                    "My Plan Screen Name".toLowerCase()
              )
                ? this.props.config_values.find(
                    (ele) =>
                      ele.targetPageTitle.toLowerCase() ===
                        "Home".toLowerCase() &&
                      ele.element.toLowerCase() ===
                        "My Plan Screen Name".toLowerCase()
                  )?.customValue
                  ? this.props.config_values
                      .find(
                        (ele) =>
                          ele.targetPageTitle.toLowerCase() ===
                            "Home".toLowerCase() &&
                          ele.element.toLowerCase() ===
                            "My Plan Screen Name".toLowerCase()
                      )
                      ?.customValue?.split("\n")
                      .map((item, key) => {
                        return (
                          <span key={key}>
                            {item === "My Plan" ? t("myPlan.title") : item}
                            <br />
                          </span>
                        );
                      })
                  : this.props.config_values
                      .find(
                        (ele) =>
                          ele.targetPageTitle.toLowerCase() ===
                            "Home".toLowerCase() &&
                          ele.element.toLowerCase() ===
                            "My Plan Screen Name".toLowerCase()
                      )
                      ?.defaultValue?.split("\n")
                      .map((item, key) => {
                        return (
                          <span key={key}>
                            {item === "My Plan" ? t("myPlan.title") : item}
                            <br />
                          </span>
                        );
                      })
                : ``}
            </h3>
            <Image
              src={myplan}
              alt="myplan"
              className={classes.stockimage}
              data-test="stockIMG"
            />
          </div>
        </div>
        {/* <div className="iframe-section">
      <iframe src={myplanUrl} title="myplan"></iframe>
      </div> */}
        <div className="s-title">
          {this.props.config_values &&
          this.props.config_values.find(
            (ele) =>
              ele.targetPageTitle.toLowerCase() === "Home".toLowerCase() &&
              ele.element.toLowerCase() === "My Plan Header".toLowerCase()
          )
            ? this.props.config_values.find(
                (ele) =>
                  ele.targetPageTitle.toLowerCase() === "Home".toLowerCase() &&
                  ele.element.toLowerCase() === "My Plan Header".toLowerCase()
              )?.customValue
              ? this.props.config_values
                  .find(
                    (ele) =>
                      ele.targetPageTitle.toLowerCase() ===
                        "Home".toLowerCase() &&
                      ele.element.toLowerCase() ===
                        "My Plan Header".toLowerCase()
                  )
                  ?.customValue?.split("\n")
                  .map((item, key) => {
                    return (
                      <span key={key}>
                        {item}
                        <br />
                      </span>
                    );
                  })
              : this.props.config_values
                  .find(
                    (ele) =>
                      ele.targetPageTitle.toLowerCase() ===
                        "Home".toLowerCase() &&
                      ele.element.toLowerCase() ===
                        "My Plan Header".toLowerCase()
                  )
                  ?.defaultValue?.split("\n")
                  .map((item, key) => {
                    return (
                      <span key={key}>
                        {item === "Plan Materials"
                          ? t("myPlan.planMaterial")
                          : item}
                        <br />
                      </span>
                    );
                  })
            : ``}
        </div>
        <div className="plans">{documentList}</div>
        <div className="text-center">{/* <Button>Load more +</Button> */}</div>
      </Container>
    );
  }
}
const mapStateToProps = (state: any) => ({
  myPlansDocuments: state.fetchMyPlansDocuments.myPlansDocuments,
  errorMessage: state.fetchMyPlansDocuments.errorMessage,
  error: state.fetchMyPlansDocuments.error,
  loading: state.fetchMyPlansDocuments.loading,
  myPlansMessage: state.fetchMyPlansDocuments.myPlansMessage,
  config_values: state.appConfig.config_values,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onFetchMyPlansDocuments: (userId, pageSize, pageNumber) =>
    dispatch(
      myPlansDocumentActions.fetchMyPlansDocuments(userId, pageSize, pageNumber)
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(MyPlan));
